import(/* webpackMode: "eager" */ "/app/app/resources/page.tsx");
